import {one_prod_sold_out} from "../http/MenuConn";
import {select_access_token} from "../http/TokenConn";
import React from "react";
import {fn_commonInitPage} from "./FnPage";

/**
 * 메뉴 관련 함수
 */

// 품절 상품 선택
export function fn_currSetMenuCode(rootStore, menuCode, menuDetail) {
    rootStore.menuStore.setMenuCode(menuCode);
    rootStore.menuStore.initMenuDetail();
    if( menuCode != "" )
        rootStore.menuStore.setMenuDetail(menuDetail);
}

// 품절 LEFT MENU 선택
export function fn_currMenuGroupList(rootStore, groupCode) {
    rootStore.menuStore.setMenuGroupCode(groupCode);
    fn_currSetMenuCode(rootStore, "", null);
    //페이지 초기화
    fn_commonInitPage(rootStore);
}

// 상품 품절 처리
export function fn_menuSoldOut(rootStore, soldOut){
    select_access_token(rootStore).then(res=> {
        one_prod_sold_out(rootStore, soldOut).then(res=>{
            if(res){
                rootStore.menuStore.updateSoldOut(soldOut);
            }
            rootStore.layerStore.setLayerSoldOutConfirmView(false)
        })
    })
}

// 상품 품절 처리(store)
export function fn_soldOutForOrder(rootStore){
    rootStore.viewStore.getOrderSoldOutProdUpdate.map(data=>{
        if( data.soldOut === "Y"){
            rootStore.menuStore.setMenuSoldOutCode(data.prodCd)
            rootStore.menuStore.updateSoldOut(true);
        }
    })
}
